import React from "react";
import NetworkStatus from "../network-status/networkStatus";
import { infoIcon } from "../../common/MotifIcons";

const PartnerUploadFooter = ({ showNetworkStatus = true }) => {
  return (
    <footer className="partner-upload-status-row">
      <p className="partner-upload-status-disclaimer">
        <img src={infoIcon} alt="" aria-hidden="true" />
        <span>
          AI-generated output may contain inaccuracies or errors. Verify the output before use.
        </span>
      </p>
      {showNetworkStatus && <NetworkStatus useToast={false} />}
    </footer>
  );
};

export default PartnerUploadFooter;
